import React from 'react';
import './DashboardCard.scss'

const CardSimple = ({ title, icon, value, subTitle = 'Rellena el subtitulo', onClick = null }) => {
  return (
    <div className="DashboardCard">
      <div className="contenido-card-dashboard">
        <div>
          <div className="contenedor-titulo">
            <img src={icon} alt="" />
            <div className="descripcion-titulo">
              <div className="titulo-card">
                {title}
              </div>
              <div className="sub-tutilo-card">
                {subTitle}
              </div>

            </div>
          </div>
          <div className="informacion-card-dashboard">
            <div className="numero-card">
              {value}
            </div>
            {
              onClick != null ?
                <button className='action-btn' onClick={onClick}>Detalle</button>
                : ""
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardSimple;
